import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { get } from "@rails/request.js"

export default class extends BridgeComponent {
  static component = "sip-call"
  static targets = ["beforeSipCall", "sipCallStatusArea", "sipCallRinging", "sipCallOnConnectFailure", "sipCallConnected"]
  static classes = ["hidden"]
  static values = {
    speaker: Boolean,
    mute: Boolean,
    sipCallUrl: String,
    sipCallNewAccessTokenUrl: String,
  }

  disconnect() {
    console.debug("sip_call controller disconnecting")
    if (this.sipCallInProgress) {
      this.send("sip_call_end", {}, () => {})
    }
  }

  async sipCallStart(event) {
    const sip_call_access_token = await this.#getSipCallAccessToken()
    this.#disableDialogClose(true)
    this.sipCallInProgress = true
    this.beforeSipCallTarget.classList.add(this.hiddenClass)
    this.sipCallStatusAreaTarget.classList.remove(this.hiddenClass)

    console.debug("starting sip call")

    this.send("sip_call_start",
      { to: this.sipCallUrlValue, call_token: sip_call_access_token },
      this.#handleSipCallStatus.bind(this))
  }

  sipCallToggleSpeaker(event) {
    console.debug("sip_call toggle speaker")
    this.send("sip_call_speaker_toggle", { },
      (speaker_message) => {
        this.speakerValue = speaker_message.data.enabled
      }
    )
  }

  sipCallToggleMute(event) {
    console.debug("sip_call toggle mute")
    this.send("sip_call_mute_toggle", { },
      (mute_message) => {
        this.muteValue = mute_message.data.enabled
      }
    )
  }

  sipCallEnd(event) {
    console.debug("sip_call sip_call_end")
    this.send("sip_call_end", {}, () => {})
    this.#sipCallEndUiUpdate()
  }

  #sipCallEndUiUpdate(){
    this.sipCallInProgress = false
    this.#disableDialogClose(false)
    this.beforeSipCallTarget.classList.remove(this.hiddenClass)
    this.sipCallStatusAreaTarget.classList.add(this.hiddenClass)
  }

  #disableDialogClose(value) {
    this.element.setAttribute("data-disable-dialog-close", value)
  }

  async #getSipCallAccessToken() {
    const response = await get(this.sipCallNewAccessTokenUrlValue, { responseKind: "application/json" })
    if (response.ok) {
      const body = await response.json
      return body.sip_call_access_token
    } else {
      throw Error("Cannot get sip call access token")
    }
  }

  #handleSipCallStatus(message) {
    console.debug(message)
    const status = message.data.status
    console.debug(status)

    const statusHandlers = {
      sip_call_connected: this.#handleSipCallConnected,
      sip_call_on_reconnected: this.#handleSipCallOnReconnected,
      sip_call_on_connect_failure: this.#handleSipCallOnConnectFailure,
      sip_call_ringing: this.#handleSipCallRinging,
      sip_call_reconnecting: this.#handleSipCallReconnecting,
      sip_call_on_disconnected: this.#handleSipCallOnDisconnected
    }

    const handler = statusHandlers[status]
    if (handler) {
      handler.call(this)
    } else {
      console.error("Unknown event_name: ", status)
    }
  }


  #getSipCallStatus() {
    this.send("get_sip_call_status", {}, (message) => {
      console.debug(message)
    })
  }

  #clearConnectionStatus() {
    this.sipCallConnectedTarget.classList.add(this.hiddenClass)
    this.sipCallOnConnectFailureTarget.classList.add(this.hiddenClass)
    this.sipCallRingingTarget.classList.add(this.hiddenClass)
  }

  #handleSipCallConnected() {
    console.debug("Connected handler")
    this.#clearConnectionStatus()
    this.sipCallConnectedTarget.classList.remove(this.hiddenClass)
  }

  #handleSipCallOnReconnected() {
    console.debug("On reconnected handler")
  }

  #handleSipCallOnConnectFailure() {
    this.#clearConnectionStatus()
    this.sipCallOnConnectFailureTarget.classList.remove(this.hiddenClass)

    this.timer = setInterval(() => {
      this.#clearConnectionStatus()
      this.#sipCallEndUiUpdate()
      clearInterval(this.timer)
    }, 2000)
  }

  #handleSipCallRinging() {
    console.debug("Ringing handler")
    this.#clearConnectionStatus()
    this.sipCallRingingTarget.classList.remove(this.hiddenClass)
  }

  #handleSipCallReconnecting() {
    console.debug("Reconnecting handler")
  }

  #handleSipCallOnDisconnected() {
    this.#clearConnectionStatus()
    this.#sipCallEndUiUpdate()
    console.debug("On disconnected handler")
  }
}
